import { Box, Flex } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSwrStale } from '../../lib/hooks';
import { useMembershipInfo } from '../../lib/hooks.context';
import { MembershipFee as Props } from '../../types';
import HtmlContent from '../HtmlContent';
import Paragraph from '../Paragraph';

import type { SiteOption } from '../SiteSelect';

const SiteSelect = dynamic(() => import('../SiteSelect'), { ssr: false });

type FeeContent = Pick<Props, 'content'>;

const MembershipBlock = ({ desc: text }: Pick<Props, 'desc'>) => {
  const { locale } = useRouter();
  const currentLocale = locale || 'fi';
  const { membershipSite, setMembershipSite } = useMembershipInfo();
  const { data } = useSwrStale<FeeContent>(
    membershipSite
      ? `/entities/membership-fee/${membershipSite}?lang=${currentLocale}`
      : null,
  );

  const feeHtml =
    typeof (data as FeeContent)?.content === 'string'
      ? (data as FeeContent).content
      : null;
  const isLoading = !!(!feeHtml && membershipSite);
  const onSelect = (option: SiteOption) => {
    setMembershipSite(option.value);
  };

  return (
    <Box data-test-id="section-membership-fee">
      <Flex flexWrap="wrap" mb={6} gridGap={5}>
        {text && (
          <HtmlContent flexBasis={['100%', 0]} flex={[null, 1]} html={text} />
        )}
        <Box
          flexBasis={['100%', 0]}
          flex={[null, 1]}
          as="form"
          noValidate
          mb={feeHtml ? 3 : 8}
          pt="2"
          maxWidth="fit-content"
        >
          <SiteSelect
            onAdd={onSelect}
            isLoading={isLoading}
            autoFocus={false}
          />
        </Box>
      </Flex>
      {feeHtml && (
        <Box py={6}>
          <HtmlContent html={feeHtml} />
        </Box>
      )}
    </Box>
  );
};

const MembershipFee = ({ desc, content }: Props) => {
  if (content) {
    return <HtmlContent html={content} />;
  }

  return <MembershipBlock desc={desc} />;
};

export default MembershipFee;
